

import {PropType} from 'vue';

export type InputType = 'text' | 'number'

export default {
    name: "SearchInput",
    emits: ['update:modelValue', 'change'],
    props: {
        type: {
            type: String as PropType<InputType>,
            default: 'text'
        },
        modelValue: null,
        label: null,
        icon: {
            default: 'fa fa-fw fa-search',
            type: String,
        },
        showClearButton: {
            type: Boolean,
            default: true,
        },
        autofillName: null,
    },
    data() {
        return {
            curValue: this.modelValue,
            itc: null,
        }
    },
    methods: {

        numberKeyDown(event) {

            const blockThisCodes = [69, 189];

            if (blockThisCodes.includes(event.keyCode)) {
                event.preventDefault();
                event.stopPropagation();
            }
        },

        labelClicked() {

            const id = this.$el.querySelector('#' + this.itc)

            if (id.nodeName.toLowerCase() === 'input') {
                id.focus();
                return;
            } else {
                this.$el.querySelector('#' + this.itc).querySelector('input').focus();
            }

        },

        clearInput() {
            this.curValue = undefined;
            this.$emit('update:modelValue', this.curValue);
            this.$emit('change', this.curValue);
            this.$el.querySelector('#' + this.itc).focus();
        },

        inputChanged() {
            this.curValue = this.curValue ? this.curValue : null;
            this.$emit('update:modelValue', this.curValue);
        },

        generateIdTooInput() {
            this.itc = 'i_' + Math.random().toString(36).substring(2);
        },

    },
    mounted() {
        this.generateIdTooInput();
    },
    watch: {

        modelValue: {
            immediate: true,
            async handler(newVal) {
                this.curValue = newVal;
            },
        },

    },

}
